import { graphql, useStaticQuery } from "gatsby";

export const useFilterExperiencesByLocationSlug = (locationPageSlugs) => {
  const { getLocationPages } = useStaticQuery(graphql`
    {
      getLocationPages: allWpLocationPage {
        nodes {
          ...WpLocationPageFragment
        }
      }
    }
  `);

  const filteredLocationPages =
    getLocationPages?.nodes?.filter((t) =>
      locationPageSlugs.includes(t.slug)
    ) ?? [];

  const getLocationPagesGeographicals =
    filteredLocationPages?.flatMap((geo) => geo?.geographical?.nodes) ?? [];

  const experienceList = getLocationPagesGeographicals
    .flatMap((locPage) => locPage?.acfCountryExploration.gviExperiences)
    .filter((experience) => experience);

  return experienceList ?? [];
};
